import { type AppDispatch } from "State/Store";
import { useDispatch } from "react-redux";

type DispatchFunc = () => AppDispatch;
export const useAppDispatch: DispatchFunc = useDispatch;
